import Dashboard from "../pages/Dashboard";
import loginSlice from "./slices/authSlice";
import  dashboardSlice  from "./slices/dashboardSlice";

const reducers = {
  login: loginSlice,
  dashboard : dashboardSlice
};

export default reducers;
